import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { installFieldBehaviors } from "@/lib/fieldBehaviors";
import Sidebar from "@/components/Sidebar";
import LockScreen from "@/components/lock/LockScreen";
import VersionWatcher from "@/components/VersionWatcher";
import ScrollLockObserver from "@/components/common/ScrollLockObserver";
import AviRealtimeOverlay from "@/components/avi/AviRealtimeOverlay";
import AviIncomingRequestModal from "@/components/avi/AviIncomingRequestModal";
import GlobalSearch from "@/components/GlobalSearch";
import ErrorBoundary from "@/components/ErrorBoundary";
import ImpersonationBanner from "@/components/ImpersonationBanner"; // eslint-disable-line no-unused-vars
import UrgentTabTitle from "@/components/UrgentTabTitle";
import { useLock } from "@/context/LockContext";

export default function AppLayout() {
  useEffect(() => installFieldBehaviors(), []);
  const { isLocked } = useLock();
  return (
    <div className="min-h-screen wallpaper" data-testid="app-shell">
      <Sidebar />
      <main className="min-h-screen app-main">
        {/* iter424 pt 7 — plus de bandeau « connecté en tant que » : indice porté par la barre de profil */}
        <div className="w-full pl-6 pr-6 pt-10 pb-6 animate-fade-in app-content">
          {/* Spec iter180 (2026-02-27) — animation opacité pure (aucun
              transform) sur le wrapper d'app. Un `transform` persistant
              créait un nouveau containing block pour les modales
              `fixed inset-0` et les scopait à ~672px au lieu du viewport
              → header hors écran (bug centrage AVI). */}
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </div>
      </main>
      {isLocked && <LockScreen />}
      {!isLocked && <AviRealtimeOverlay />}
      {!isLocked && <AviIncomingRequestModal />}
      {!isLocked && <GlobalSearch />}
      <VersionWatcher />
      <ScrollLockObserver />
      <UrgentTabTitle />
    </div>
  );
}
